import {Sheet} from 'xlsx';
import {fetchAuthSession} from "aws-amplify/auth";

export function extractWorkSheetData(sheet: Sheet): any[] {

    //as we need to return 3 values, we end up putting them in an array and returning that
    let resultsArray: any[] = [];

    //get yo sheet and get out :~)
    let objectData: any = sheet;
    //console.log(objectData, "Sheet Data");

    //getting keys which in this case are the cells names as the values are the objects of cell data
    let objectKeys = Object.keys(objectData);

    //extracting the values (more objects corresponding to cell values) from the Census Sheet Object and putting it into an array of objects
    let arrayValues: any[] = Object.values(objectData);
    //console.log(arrayValues, "This one?");

    //column and row range string that is conveniently the first value in our new array of objects
    let rangeValueString: string = arrayValues[0];

    //This value starts with "A1:" and is formatted "A1:AQ786" so gotta skip the first 3 char and get only the column not row range
    let columnRangeString: string = "";

    //loop through the range string starting at the fourth character(zero based index) checking if the chars are letters as end Column length can vary based on total columns
    for (let i = 3; i < rangeValueString.length; i++) {
        //just a regex on the character at each index and appending it to the empty string as letters are found
        if (isLetter(rangeValueString.charAt(i))) {
            columnRangeString += rangeValueString.charAt(i);
        }
    }

    //this one's complicated, but basically it's raising 26 to a power based on input length-1 for each char, then multiplying by the value of the index of each char
    //new and old might have different sizes but gotta be safe

    let columnRange : number = convertExcelColumnRangeToInt(columnRangeString);

    //ayo lets get that row total now for THE ULTIMATE LOOP
    let rowRangeString = "";

    for (let i = 4; i < rangeValueString.length; i++) {
        //just a regex on the character at each index and appending it to the empty string as numbers are found
        if (isNumber(rangeValueString.charAt(i))) {
            rowRangeString += rangeValueString.charAt(i);
        }
    }

    //STRING NOW NUMBER OOGA BOOGA

    let rowRange = Number(rowRangeString);

    //super inefficient but I need to crawl through the spreadsheet and find blank cells(missing keys), creating them when skipped and appending an index based on their
    //cell location for later insertion into the array at the correct location

    for (let i = 0; i < columnRange; i++){
        let columnTitle = numberToLetters(i);
        for(let j = 1; j <= rowRange; j++){
            if (!objectKeys.includes(columnTitle + j.toString())){
                let newCellObject = columnTitle + j.toString();
                let positionIndex = (i + ((j - 1) * columnRange));
                objectData[newCellObject] = {t: "z", i: positionIndex};
            }
        }
    }

    //set it again with added blank cells
    arrayValues = Object.values(objectData);

    //The first value returned by the values call is the range of relevant cells, so we extract the ranges then skip over it later for our cell array
    let rawCellArray: any[] = new Array(arrayValues.length - 1);

    //for our blank indexes we added
    let blankCellIndexes: any[] = [];
    //create an array out of the objects in arrayValues where v is the property holding the string you need. This spits out an ordered array of all cells A1->A2->A3
    //and so on. zero based, but we skip the first because it's a range string value we don't want here. Also, cells of type z are blank and dont have a value,
    //but we still need them to maintain the order of data so we check for them. If the z cells also have our index value, it means we added them out of order and need to
    // insert them in the correct spot to maintain the sequence, but this must happen in order so we make an array and sort it before sequentially inserting them
    for (let index = 1; index < arrayValues.length; index++) {
        if(arrayValues[index].t === "z"){
            if(arrayValues[index].i > 0){
                blankCellIndexes.push(arrayValues[index].i);
            }else {
                rawCellArray[index - 1] = "";
            }
        }
        else {
            rawCellArray[index - 1] = arrayValues[index].v;
        }
    }

    //sort our missing blanks so they insert in the correct order
    blankCellIndexes.sort(function(a, b){return a-b});
    //insert missing blanks
    blankCellIndexes.forEach((x) => {rawCellArray.splice(x, 0, "")});
    //console.log(rawCellArray, "Raw Data");
    resultsArray.push(rawCellArray, columnRange, rowRange);

    return resultsArray;
}

export function isLetter(str : string) {
    return str.length === 1 && str.match(/[a-z]/i);
}

export function isNumber(str : string) {
    return str.length === 1 && str.match(/[0-9]/i);
}

export function numberToLetters(num : number) {
    let letters = ''
    while (num >= 0) {
        letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
        num = Math.floor(num / 26) - 1
    }
    return letters
}

export function convertExcelColumnRangeToInt(val: string): number {
    var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', i, j, result = 0;

    for (i = 0, j = val.length - 1; i < val.length; i += 1, j -= 1) {
        result += Math.pow(base.length, j) * (base.indexOf(val[i]) + 1);
    }

    return result;
}

export function isEmpty(excelData: object): boolean {
    for (const prop in excelData) {
        if (Object.hasOwn(excelData, prop)) {
            return false;
        }
    }

    return true;
}

//splitting up a date to yyyymmdd
export function formatDate (dateString: string) {
    const firstSlashIndex = dateString.indexOf("/");
    const lastSlashIndex = dateString.lastIndexOf("/");
    let year: string;
    let month: string;
    let day: string;
    if (firstSlashIndex > 1){
        month = dateString.substring(0, 2);
    }
    else {
        month = "0" + dateString.substring(0, 1);
    }
    if (lastSlashIndex - firstSlashIndex === 3){
        day = dateString.substring(firstSlashIndex + 1, lastSlashIndex);
    }
    else {
        day = "0" + dateString.substring(firstSlashIndex + 1, lastSlashIndex);
    }

    year = dateString.substring(lastSlashIndex + 1);

    return year + month + day;
}

//converting excel day count to yyyymmdd
export function ExcelDateToDateString(serial : string) {
    let serialNumber : number = Number(serial);
    let utc_days  = Math.floor(serialNumber - 25568);
    let utc_value = utc_days * 86400;
    let date_info = new Date(utc_value * 1000);

    let year = date_info.getFullYear().toString();
    let month = (date_info.getMonth() + 1) < 10 ? "0" + (date_info.getMonth() + 1).toString() : (date_info.getMonth() + 1).toString();
    let day = date_info.getDate() < 10 ? "0" + date_info.getDate().toString() : date_info.getDate().toString();


    return (year + month + day);
}

export const getCurrentSession = async () => {
    const session = await fetchAuthSession({forceRefresh: true});
    //console.log("Token: ",session);
    return session.tokens?.idToken?.toString();
}

export const refreshToken = () => {
    getCurrentSession().then(jwt => jwt ? localStorage.setItem('jwt', jwt) : localStorage.setItem('jwt', ""));
    //console.log(localStorage.getItem('jwt'));
}

export function setWithExpiry(key : string, value : string) {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire - 8 hours
    const item = {
        value: value,
        expiry: now.getTime() + 3600000,
    };

    localStorage.setItem(key, JSON.stringify(item));
}

export function getWithExpiry(key : string) {
    const itemStr = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key);
        return null;
    }

    return item.value;
}